export const state = {
	//Constants
	breakfastOptions: [
		{ label: 'Breakfast', value: 'breakfast' },
		{ label: 'Lunch', value: 'lunch' },
		{ label: 'Dinner', value: 'dinner' },
		{ label: 'Snacks', value: 'snacks' },
	],
	moodOptions: [
		{ value: 1, label: 'Happy' },
		{ value: 2, label: 'Sad' },
		{ value: 3, label: 'Angry' },
		{ value: 4, label: 'Relaxed' }
	],
	weightOptions: [
		{ value: 0, label: 'Kilograms', alias: 'kg' },
		{ value: 1, label: 'Pounds', alias: 'lb' }
	],

	bowelMovementsOptions: [
	    { value: 1, label: 'Nut' },
	    { value: 2, label: 'Grape' },
	    { value: 3, label: 'Cracked' },
	    { value: 4, label: 'Banana' },
	    { value: 5, label: 'Soft' },
	    { value: 6, label: 'Porridge' },
	    { value: 7, label: 'Watery' }
	],
	poopColorOptions: [
	    { value: 'Brown', label: 'Brown' },
	    { value: 'Green', label: 'Green' },
	    { value: 'White', label: 'White' },
	    { value: 'Red', label: 'Red' },
	    { value: 'Black', label: 'Black' },
	    { value: 'Yellow', label: 'Yellow' },
	    { value: 'Orange', label: 'Orange' }
	],
	poopExperienceOptions: [
	    { value: 1, label: 'Bloating' },
	    { value: 2, label: 'Burping' },
	    { value: 3, label: 'Gas' },
	    { value: 4, label: 'Acid Reflux' },
	    { value: 5, label: 'Indigestion' }
	],
	timeDurationOptions: [
	    { value: 1, label: '1 min or less' },
	    { value: 2, label: '2-5 min' },
	    { value: 3, label: '5-10 min' },
	    { value: 4, label: '10+ min' }
	],
	pushPressureOptions: [
	    { value: 1, label: 'Easy to pass' },
	    { value: 2, label: 'Average' },
	    { value: 3, label: 'Hard to pass' }
	],
	poopComplicationsOptions: [
	    { value: 0, label: 'None' },
	    { value: 1, label: 'Blood' },
	    { value: 2, label: 'Pain' }
	],
	
	diseaseList :[],
	prescriptionList : {},
	prescriptionView :[],
	testReportList : {},
	testReportDetail :{},
	appointmentList : {},
	appointmentDetail : {},
	appointmentInfo : {},
	notificationList : [],
	initialData: {
		bp: {},
		energy: {},
		glucose: {},
		food: {},
		mood: {},
		weight: {},
		heart: {},
		sleep: {},
		steps: {},
	},
	chartData: {
		bp: [],
		sleep: [],
		heart: [],
		glucose: [],
		weight: [],
		steps: [],
	},
	glucoseChartHistoryData: {},
	weightChartHistoryData: {},
	bpChartHistoryData: {},
	sleepChartHistoryData: {},
	stepsChartHistoryData: {},
	heartChartHistoryData: {},  
	totalSlotList :[],
	busySlotList : [],
	patientBusySlot : [],

	medicineList : {},
	taskActionList: {},
	checkObtCall : {},



}


// WEBPACK FOOTER //
// ./src/plugins/Gini/provider/candle-history/store-addons/state.js